import { LOCAL_STORAGE } from 'constants/app';
import { Modal } from 'carbon-components-react';
import PortalModal from 'components/PortalModal';
import { useStore } from 'effector-react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { useTime, useTimer } from 'react-timer-hook';
import { $mainStore } from 'store/main';
import { $userStore } from 'store/user';
import { refreshTokenFX } from 'store/user/effects';
import { refreshTokenEV, setAccountUuidEV } from 'store/user/events';
import { setProfileTypeEV, updateLastActivityEV } from 'store/main/events';
import { addZeroToNumberBefore } from 'utils/addZeroToNumberBefore';
import { useProfile } from '../../hooks/useProfile';
import { logout } from '../../utils/logout';
import { ProfileTypeEnum } from '../../store/main/interface';
import { partnerOrganizationProfileIsActive } from '../../store/partnerOrganizations/effects';

export const SessionExpireModal = () => {
  const lastRefresh = localStorage.getItem(LOCAL_STORAGE.LAST_TOKEN_REFRESH);
  const { session_expired } = useProfile().data;
  const timerTime = 5; // minutes;
  const maxNotActivityTime = (session_expired || 20) - timerTime - 1; // aftex maxNotActivityTime mins show popup "continue session"
  const { lastActivity } = useStore($mainStore);
  const { t } = useTranslation();
  const time = useTime({ format: '12-hour' });
  const expiryTimestamp = moment().add(timerTime, 'minutes').toDate();
  const [openModal, setOpenModal] = useState(false);
  const user = useStore($userStore);
  const isRefreshing = useStore(refreshTokenFX.pending);
  const [, , removeCookie] = useCookies(['web_epak']);

  const handleCloseModal = () => setOpenModal(false);

  const handleLogout = () => {
    logout(removeCookie);
    handleCloseModal();
  };

  const handleSubmit = async () => {
    const profileType = localStorage.getItem(LOCAL_STORAGE.PROFILE_TYPE);
    const profileUuid = localStorage.getItem(LOCAL_STORAGE.UUID);

    if (profileType === ProfileTypeEnum.PARTNER_ORGANIZATION && profileUuid) {
      try {
        await partnerOrganizationProfileIsActive({ uuid: profileUuid });
      } catch (response) {
        if ((response as { status?: number }).status === 403) {
          const personUuid = user?.accounts.natural_person.uuid || user?.user_profile_uuid;

          if (personUuid) {
            setProfileTypeEV(ProfileTypeEnum.PERSON);
            setAccountUuidEV(personUuid);
          }
        }
      }
    }

    const sub = refreshTokenFX.doneData.watch(() => {
      handleCloseModal();
      sub.unsubscribe();
    });
    refreshTokenEV();
    updateLastActivityEV();
    pause();
  };

  const { seconds, minutes, restart, pause } = useTimer({
    expiryTimestamp,
    onExpire: handleLogout,
  });

  useEffect(() => {
    pause();
  }, []);

  useEffect(() => {
    if (user) {
      const now = moment();
      const diff = now.diff(lastActivity, 'seconds');

      if (diff === maxNotActivityTime * 60) {
        const newExpiryTimestamp = now.clone().add(timerTime, 'minutes').toDate();
        console.log('show session ends modal', new Date());

        setOpenModal(true);
        restart(newExpiryTimestamp);
      }

      if (lastRefresh && moment(lastRefresh ?? 0 * 1000).diff(now, 'seconds') < -timerTime * 60) {
        refreshTokenEV();
      }
    }
  }, [time.seconds]);

  return (
    <>
      {openModal && (
        <PortalModal>
          <Modal
            size="sm"
            modalLabel=""
            primaryButtonText={t('CONTINUE_SESSION')}
            primaryButtonDisabled={isRefreshing}
            secondaryButtonText={t('END_SESSION')}
            open={openModal}
            onRequestSubmit={handleSubmit}
            onRequestClose={handleLogout}
            className="web-epak__modal"
          >
            <div className="web-epak__modal-blok">
              <div className="web-epak__modal-timer">
                {t('SESSION_WILL_EXPIRE_IN')}:{' '}
                <span>
                  {minutes}:{addZeroToNumberBefore(seconds)}
                </span>
              </div>
            </div>
          </Modal>
        </PortalModal>
      )}
    </>
  );
};
